import { useSelector } from 'react-redux'
import CardTAG from '../CardTAG'
import PageBodyLayout from '../PageBodyLayout'
import ReportSubheader from '../ReportSubheader'
import reportsSelectors from '../../store/reports/reportsSelectors'
import ICaseUpdates from '../InitialReport/CaseUpdates'
import DataPart from '../CaseInvestigation/DataPart'
import { useState } from 'react'
import { IAnswerFiles } from '../CaseInvestigation/types'

const CaseUpdates: React.FC = () => {
  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const [answersFiles, setAnswersFiles] = useState<IAnswerFiles[]>([])
  
  return (
    <PageBodyLayout
      caseSubheader={<ReportSubheader />}
      filterPart={
        <CardTAG title='Case Updates'>
          <div className='t-font-size-body'>
            Additional information or updates related to an ar chived case can be added here
          </div>
        </CardTAG>
      }
      dataPart={
        <div className='t-initial-report-questions'>
          <DataPart archivedCase setAnswersFiles={setAnswersFiles} answersFiles={answersFiles} />
          <ICaseUpdates selectedReport={selectedReport} />
        </div>
      }
    />
  )
}

export default CaseUpdates
